import { render, staticRenderFns } from "./viewScore.vue?vue&type=template&id=9a009468&scoped=true&"
import script from "./viewScore.vue?vue&type=script&lang=js&"
export * from "./viewScore.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/project-detail.css?vue&type=style&index=0&id=9a009468&scoped=true&lang=css&"
import style1 from "./viewScore.vue?vue&type=style&index=1&id=9a009468&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a009468",
  null
  
)

export default component.exports